<form [formGroup]="modalForm" (ngSubmit)="onFormSubmit()">
  <app-modal-container>
    <span class="modal-header-content">
      {{ modalHeader || 'rule_action_modal_title_' + actionType + '_issues' | translate }}
    </span>

    <div class="modal-body-content d-flex flex-column">
      <p class="body-content-heading">
        {{ modalTitle || 'rule_action_modal_description_all_issues_' + actionType | translate }}
      </p>
      @if (!hideRuleTitle) {
        <div class="d-flex flex-column align-items-start">
          <p>
            <b>{{ 'title' | translate }}: </b>{{ ruleTitle }}
          </p>
        </div>
      }
      <div class="d-flex flex-column align-items-start">
        <label for="reason" class="label margin-bottom-xs text-nowrap">{{ 'label_reason_required' | translate }}</label>
        <textarea id="reason" name="reason" formControlName="reason" class="form-element w-100" rows="6"></textarea>
      </div>
      <div class="d-flex flex-column align-items-start">
        <app-form-field-error
          [formValidationRequest$]="formValidationRequest$"
          [field]="modalForm.controls['reason']"
          [name]="'Reason'"
          [label]="'reason'"
        ></app-form-field-error>
      </div>
    </div>

    <div class="modal-footer-content">
      <div class="d-flex justify-content-between">
        <button class="btn btn-outline-primary" (click)="close()">
          {{ 'label_close' | translate }}
        </button>
        <button class="btn btn-primary margin-left" type="submit" >
          {{ 'label_' + actionType + '_button' | translate }}
        </button>
      </div>
    </div>
  </app-modal-container>
</form>
